/**
 * Phone menu drill-down (snippets/header-mobile-drilldown.liquid).
 *
 * One screen at a time. Opening a row builds its screen from a <template> the first time,
 * slides it in, and moves focus to its title; Back (or Escape) returns to the screen before and
 * to the row that opened it. The theme's own code still opens, closes and traps focus in the
 * menu as a whole - this only decides which screen inside it is showing.
 */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  class MobileDrilldown extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = "1";

      this.root = this.querySelector("[data-mdd-panel='root']");
      this.inner = this.closest(".mobile-menu-inner") || this.parentElement;
      // Each entry: { panel, opener }. The root screen is always at the bottom.
      this.stack = [{ panel: this.root, opener: null }];

      var self = this;
      this.addEventListener("click", function (event) {
        var opener = event.target.closest("[data-mdd-open]");
        if (opener && self.contains(opener)) {
          var panel = self.panelFor(opener.getAttribute("data-mdd-open"));
          if (panel) {
            event.preventDefault();
            self.push(panel, opener);
          } else if (self.hasAttribute("data-mdd-lazy") && window.headerMenus) {
            event.preventDefault();
            self.openWhenLoaded(opener);
          }
          return;
        }
        if (event.target.closest("[data-mdd-back]")) {
          event.preventDefault();
          self.pop();
        }
      });

      this.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && self.stack.length > 1) {
          event.stopPropagation();
          self.pop();
        }
      });

      // Closing the menu puts it back to its first screen for next time.
      document.addEventListener("mobile-menu:close", function () {
        self.reset();
      });
    }

    /**
     * Screens past the first are fetched once the menu button is touched (assets/header-menus.js).
     * A row tapped before they arrive opens its screen when they do; if they cannot be fetched,
     * it goes to the row's collection instead.
     */
    openWhenLoaded(opener) {
      var self = this;
      opener.setAttribute("aria-busy", "true");
      window.headerMenus
        .load("phone")
        .then(function () {
          var panel = self.panelFor(opener.getAttribute("data-mdd-open"));
          if (!panel) throw new Error("No screen for " + opener.getAttribute("data-mdd-open"));
          self.push(panel, opener);
        })
        .catch(function () {
          var url = opener.getAttribute("data-mdd-url") || opener.getAttribute("href");
          if (url) window.location.href = url;
        })
        .then(function () {
          opener.removeAttribute("aria-busy");
        });
    }

    /** The screen for an id, built from its template on first use. */
    panelFor(id) {
      var panel = this.querySelector(":scope > [data-mdd-panel='" + id + "']");
      if (panel) return panel;
      var template = this.querySelector(":scope > template[data-mdd-template='" + id + "']");
      if (!template) return null;
      this.appendChild(template.content.cloneNode(true));
      template.remove();
      return this.querySelector(":scope > [data-mdd-panel='" + id + "']");
    }

    push(panel, opener) {
      var from = this.stack[this.stack.length - 1].panel;
      var label = panel.querySelector("[data-mdd-back-label]");
      if (label) label.textContent = from.getAttribute("data-mdd-title") || label.textContent;

      this.stack.push({ panel: panel, opener: opener });
      this.show(panel, "forward");
    }

    pop() {
      if (this.stack.length < 2) return;
      var leaving = this.stack.pop();
      var back = this.stack[this.stack.length - 1];
      this.show(back.panel, "back", leaving.opener);
    }

    reset() {
      if (this.stack.length < 2) return;
      this.stack = [this.stack[0]];
      this.show(this.root, null);
    }

    show(panel, direction, focusAfter) {
      Array.prototype.forEach.call(this.querySelectorAll(":scope > [data-mdd-panel]"), function (other) {
        var on = other === panel;
        other.hidden = !on;
        other.classList.remove("mdd-in-forward", "mdd-in-back");
      });
      if (direction && !REDUCED) panel.classList.add("mdd-in-" + direction);

      var deep = panel !== this.root;
      this.classList.toggle("mdd-deep", deep);
      if (this.inner) {
        this.inner.classList.toggle("mdd-inner-deep", deep);
        this.inner.scrollTop = 0;
      }

      var target = focusAfter || panel.querySelector("[data-mdd-heading]");
      if (!target && !deep) target = this.root.querySelector("input, button, a");

      // The theme's focus trap (assets/scripts.js) notes the menu's first and last focusable
      // elements when the menu opens. A new screen changes both, so the trap is set again or
      // Tab would walk out of the menu from what is now its last item.
      var wrap = this.closest(".head-slot-nav-mobile-link-wrapper");
      if (wrap && typeof window.trapFocus === "function" && document.body.classList.contains("mobile-menu-open")) {
        window.trapFocus(wrap, target || this);
      } else if (target) {
        target.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get("mobile-drilldown")) {
    customElements.define("mobile-drilldown", MobileDrilldown);
  }
})();
